import UsersPage, { getDefaultData } from "components/pages/UsersPage";
import { BCMSDefaultModel, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes, { TransferTemplate, UserAccount } from "model";
/**
 * @name CaptureUsersMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureUsersMain(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    let userAccounts = getDefaultData().userAccounts;
    let defaultUser = BCMSDefaultModel.userAccount();
    defaultUser = UserAccount.init({ ...defaultUser.record, id: UserAccount.nextID() });
    userAccounts = [ ...userAccounts, defaultUser ];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "userAccounts" ], userAccounts)
    .submit();

    return <UsersPage data={ data } />;
}